import logger from '@finn-no/fiaas-logger';
import type { NextPage } from 'next';
import { getPageCounter } from 'shared/prometheus/prometheus';
import type { SspContext } from 'shared/types';
import { fetchOffers, fetchOffersForMap } from '@/api/fetcher';
import { MapResultPage } from '@/components/map/MapResultPage';
import { config, feConfig } from '@/config';
import { browserQueryParamsToFilters, filtersToApiQueryParams } from '@/lib/utils/queryParamFilterConversions';
import { runAllMiddlewares } from '@/server/middleware';
import { actions as filterActions } from '@/state/filterActions';
import { actions as mapResultActions } from '@/state/mapResultActions';
import { actions as resultActions } from '@/state/resultActions';
import { wrapper } from '@/state/store';

type MapPageProps = {
    hasLegalBasis: boolean;
    unleash: Record<string, boolean> | null;
    config: typeof feConfig;
};

const MapPage: NextPage<MapPageProps> = (props: MapPageProps) => {
    wrapper.useHydration(props);

    return <MapResultPage />;
};

export const getServerSideProps = wrapper.getServerSideProps((store) => async ({ req, res, query }: SspContext) => {
    if (query.skipSSRData) {
        return { props: { hasLegalBasis: false, unleash: null, config: feConfig } };
    }

    await runAllMiddlewares(req, res, query);

    const filters = browserQueryParamsToFilters(query);
    store.dispatch(filterActions.filter(filters));

    try {
        const data = await fetchOffers(config.get('pp.apiUrlInternal'), filtersToApiQueryParams(filters));
        store.dispatch(resultActions.setResults(data));

        const pois = await fetchOffersForMap(config.get('pp.apiUrlInternal'), filtersToApiQueryParams(filters));
        store.dispatch(mapResultActions.setMapResults(pois));
    } catch (error) {
        store.dispatch(resultActions.setError());
        store.dispatch(mapResultActions.setError());
        logger.error(`Failed to fetch offers for map page: ${error}`);
    }

    getPageCounter().inc({ app: 'pale-pp-web', page: 'map' });

    return {
        props: {
            hasLegalBasis: res.locals?.hasLegalBasis ?? false,
            unleash: res.locals?.unleash ?? null,
            config: feConfig,
        },
    };
});

export default MapPage;
